<template>
  <div class="login-screen">
    <div class="login-card d-flex flex-column align-items-center gap-3">
      <BrandMark :size="64" />
      <div>
        <h1 class="h4 mb-2">Dir fehlt die Berechtigung</h1>
        <p class="text-body-secondary mb-0">Bitte wende dich an Michael oder Patrick, damit sie dir Zugriff geben.</p>
      </div>
      <button type="button" class="btn btn-outline-secondary w-100 mt-2" @click="logout">Mit anderem Konto anmelden</button>
    </div>
  </div>
</template>

<script setup>
import BrandMark from "@/components/frame/BrandMark.vue";
import { AuthenticationContext } from "@/auth/msal-context";

defineOptions({ name: "MissingRole" });

const logout = () => AuthenticationContext.logout();
</script>
